import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this.isOpen = false;
    document.addEventListener("click", this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  toggle(e) {
    e.preventDefault();
    this.isOpen = !this.isOpen;
    this.update();
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      this.update();
    }
  }

  update() {
    const menu = this.menuTarget;

    if (this.isOpen) {
      menu.classList.remove("opacity-0", "translate-y-1", "pointer-events-none");
      menu.classList.add("opacity-100", "translate-y-0");
      this.buttonTarget.setAttribute("aria-expanded", "true");
    } else {
      menu.classList.add("opacity-0", "translate-y-1", "pointer-events-none");
      menu.classList.remove("opacity-100", "translate-y-0");
      this.buttonTarget.setAttribute("aria-expanded", "false");
    }
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  };
}
